import type { ComponentProps } from "react";
import { Box } from "../../../../styled-system/jsx";

export function ExplainerBox(props: ComponentProps<typeof Box>) {
  return (
    <Box
      display={"flex"}
      gap={"small"}
      flexDirection={`column`}
      border={"1px solid {colors.lightgrey}"}
      borderRadius={"light"}
      padding={"large"}
      fontSize={"small"}
      backgroundColor={"nav"}
      {...props}
    />
  );
}
